export default [
  {
    State: 'New Hampshire',
    alcoholConsumptionGallons: 4.76,
  },
  {
    State: 'Delaware',
    alcoholConsumptionGallons: 3.72,
  },
  {
    State: 'Nevada',
    alcoholConsumptionGallons: 3.46,
  },
  {
    State: 'North Dakota',
    alcoholConsumptionGallons: 3.26,
  },
  {
    State: 'Montana',
    alcoholConsumptionGallons: 3.11,
  },
  {
    State: 'Vermont',
    alcoholConsumptionGallons: 3.08,
  },
  {
    State: 'Wisconsin',
    alcoholConsumptionGallons: 2.98,
  },
  {
    State: 'Alaska',
    alcoholConsumptionGallons: 2.94,
  },
  {
    State: 'Idaho',
    alcoholConsumptionGallons: 2.92,
  },
  {
    State: 'South Dakota',
    alcoholConsumptionGallons: 2.87,
  },
  {
    State: 'Maine',
    alcoholConsumptionGallons: 2.81,
  },
  {
    State: 'Colorado',
    alcoholConsumptionGallons: 2.81,
  },
  {
    State: 'Minnesota',
    alcoholConsumptionGallons: 2.77,
  },
  {
    State: 'Oregon',
    alcoholConsumptionGallons: 2.75,
  },
  {
    State: 'Wyoming',
    alcoholConsumptionGallons: 2.67,
  },
  {
    State: 'Florida',
    alcoholConsumptionGallons: 2.65,
  },
  {
    State: 'Hawaii',
    alcoholConsumptionGallons: 2.63,
  },
  {
    State: 'Louisiana',
    alcoholConsumptionGallons: 2.59,
  },
  {
    State: 'Rhode Island',
    alcoholConsumptionGallons: 2.57,
  },
  {
    State: 'Massachusetts',
    alcoholConsumptionGallons: 2.57,
  },
  {
    State: 'Missouri',
    alcoholConsumptionGallons: 2.49,
  },
  {
    State: 'Connecticut',
    alcoholConsumptionGallons: 2.45,
  },
  {
    State: 'Iowa',
    alcoholConsumptionGallons: 2.4,
  },
  {
    State: 'Pennsylvania',
    alcoholConsumptionGallons: 2.36,
  },
  {
    State: 'Texas',
    alcoholConsumptionGallons: 2.34,
  },
  {
    State: 'New Jersey',
    alcoholConsumptionGallons: 2.34,
  },
  {
    State: 'Michigan',
    alcoholConsumptionGallons: 2.34,
  },
  {
    State: 'California',
    alcoholConsumptionGallons: 2.33,
  },
  {
    State: 'Illinois',
    alcoholConsumptionGallons: 2.32,
  },
  {
    State: 'Arizona',
    alcoholConsumptionGallons: 2.31,
  },
  {
    State: 'New Mexico',
    alcoholConsumptionGallons: 2.27,
  },
  {
    State: 'Washington',
    alcoholConsumptionGallons: 2.26,
  },
  {
    State: 'Nebraska',
    alcoholConsumptionGallons: 2.23,
  },
  {
    State: 'Mississippi',
    alcoholConsumptionGallons: 2.23,
  },
  {
    State: 'South Carolina',
    alcoholConsumptionGallons: 2.22,
  },
  {
    State: 'New York',
    alcoholConsumptionGallons: 2.22,
  },
  {
    State: 'Indiana',
    alcoholConsumptionGallons: 2.17,
  },
  {
    State: 'Maryland',
    alcoholConsumptionGallons: 2.15,
  },
  {
    State: 'Virginia',
    alcoholConsumptionGallons: 2.14,
  },
  {
    State: 'Tennessee',
    alcoholConsumptionGallons: 2.14,
  },
  {
    State: 'North Carolina',
    alcoholConsumptionGallons: 2.13,
  },
  {
    State: 'Ohio',
    alcoholConsumptionGallons: 2.04,
  },
  {
    State: 'Alabama',
    alcoholConsumptionGallons: 2.01,
  },
  {
    State: 'Kentucky',
    alcoholConsumptionGallons: 1.98,
  },
  {
    State: 'Georgia',
    alcoholConsumptionGallons: 1.94,
  },
  {
    State: 'Kansas',
    alcoholConsumptionGallons: 1.92,
  },
  {
    State: 'Oklahoma',
    alcoholConsumptionGallons: 1.88,
  },
  {
    State: 'Arkansas',
    alcoholConsumptionGallons: 1.8,
  },
  {
    State: 'West Virginia',
    alcoholConsumptionGallons: 1.76,
  },
  {
    State: 'Utah',
    alcoholConsumptionGallons: 1.34,
  },
];
